import {Injectable, OnDestroy} from '@angular/core';

import {ReplaySubject} from 'rxjs';
import {distinctUntilChanged, filter, takeUntil} from 'rxjs/operators';

import {RouteStore} from '@stores/route.store';
import {PosthogWrapperService} from '@services/posthog-wrapper.service';

import {UtilsPL2 as U} from '@common/utils/dist/utils/utils-pl2.js';

import {environment} from '../../environments/environment';

type PostHogProperties = Record<string, string | string[]>;

@Injectable({
  providedIn: 'root',
})
export class PosthogRouteReactor implements OnDestroy {
  private _destroyed$ = new ReplaySubject<void>();

  constructor(
    private routeStore: RouteStore,
    private posthogWrapperService: PosthogWrapperService,
  ) {
    if (U.isEmpty(environment.posthogApiKey)) {
      return;
    }
    // Track page views automatically using RouteStore
    this.routeStore.state$
      .pipe(
        filter((state) => !U.isEmpty(state?.url)),
        distinctUntilChanged((prev, curr) => prev.url === curr.url),
        takeUntil(this._destroyed$),
      )
      .subscribe((state) => {
        const pageProperties: PostHogProperties = U.excludeEmptyProperties({
          url: state.url,
          containerId: state.containerId,
          pageName: state.pageName,
          viewType: state.view,
          path: state.url?.split('?')[0],
        });
        this.posthogWrapperService.capture('$pageview', pageProperties);
      });
  }

  ngOnDestroy() {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
